 // Export
 module.exports =
 {
    createPopup: 
    {
        test_mode: false,
        test_mode_types: ["call-back",],
        test_mode_type: "success",

        holding_interval: null,

        modals: 
        {
            "call-back": 
            {
                display: 'flex', // display type
                colour: '#EBF8FD', // background colour
                height: '0.77790178571',  // percentage of screen height to set height
                width: "728px",
                maxWidth: "calc(100vw - 40px)",
                invertCross: true, // invert the colours of the modal close cross
                center: true,
            }, 
            unavailable:
            {
                display: 'flex', 
                colour: '#2B8CC6',
                height: '0.56473214285',
                width: "632px",
                maxWidth: "calc(100vw - 40px)",
                center: true,
            },
            available:
            {
                display: 'flex',
                colour: '#2B8CC6',
                height: '0.48555555555',
                minHeight: '461px',
                width: "632px",
                maxWidth: "calc(100vw - 40px)",
                center: true,
            },
            requested:
            {
                display: 'flex',
                colour: '#2B8CC6',
                height: '0.48555555555',
                minHeight: '461px',
                width: "632px",
                maxWidth: "calc(100vw - 40px)",
                center: true,
            },
        },
        selected_modal: "",
        
        _init: function ()
        {
            if($('body').hasClass('waiting-for-modal'))
            {
                return
            }

            let modal = $('#one-touch-switching-modal-type').val()

            if(!this.handleErrors(modal, true, false)){
                this.setupModal(modal)
                this.callMeBackButton()
                this.requestCallBackButton()
            }
            
        },

        handleErrors: function (modal, close, in_modal){
            try {
                $(".form-control-feedback, .help-block").remove()
                $(".form-group").removeClass("has-error")
                $(".form-group").removeClass("has-feedback")

                let json = JSON.parse(modal)

                Object.keys(json).forEach(function(key){
                    let selector = in_modal ? $(`.one-touch-switching-modal-body [name='${key}']`) : $(`form [name='${key}']`);
                    selector.after(`<span class="fa fa-times form-control-feedback"></span>`)
                    selector.closest('.form-group').addClass('has-error')
                    selector.closest('.form-group').addClass('has-feedback')
                    selector.closest('.feedback-group').before(`<p class="help-block text-danger small">${json[key]}</p>`)
                })

                if(close){
                    this.resetModal()
                }
                else if(in_modal && Object.keys(json).length > 0){

                    $('.one-touch-switching-modal-main-scroll').animate({
                    scrollTop: $(`.one-touch-switching-modal-body .form-group:has([name='${Object.keys(json).at(0)}'])`).offset().top - $('.one-touch-switching-modal-main-scroll').offset().top + $('.one-touch-switching-modal-main-scroll').scrollTop()
                    }, 500)

                }

                return true
            }
            catch (e) {
                return false
            }
        },

        callMeBackButton: function(){
            let this_class = this
            $("#one-touch-switching-modal-call-back-button").on("click", function(){
                this_class.showModal("call-back")
            })
        },

        requestCallBackButton: function () {
            $("#one-touch-switching-modal-check").on("click", () => {

                let params = {
                    "title": $('#one_touch_switching_title').val(),
                    "first_name": $('#one_touch_switching_first_name').val(),
                    "surname": $('#one_touch_switching_surname').val(),
                    "phone_number": $('#one_touch_switching_daytime_phone_number').val(),
                    "email_address": $('#one_touch_switching_email').val(),
                    "postcode": $('#one_touch_switching_postcode').val(),
                    "address": $('#one_touch_switching_address').val(),
                    "broadband_name": $('#one_touch_switching_provider_name').val(),
                    "provider_number": $('#one_touch_switching_provider_number').val(),
                    "switch_date": $('#one_touch_switching_switch_date').val(),
                    "contact_type": $('#one_touch_switching_contact_type').val(),
                    "call_me_back": 1
                }
                

                fetch("/one-touch-switching?modal=1", {
                    method: "POST",
                    headers: {
                        "Content-type": "application/x-www-form-urlencoded; charset=UTF-8"
                    },
                    body: $.param(params),
                })
                .then(response => 
                    response.text()
                )
                .then((response) => {
                    if(!this.handleErrors(response, false, true)){
                        this.showModal("requested")
                    }
                })
            })
        },

        modalResize: function () {
            if(this.modals[this.selected_modal].height){
                $(`#one-touch-switching-modal-${this.selected_modal}`)?.css("height", this.modals[this.selected_modal].height * Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0))
            }
            if(this.modals[this.selected_modal].px_height){
                $(`#one-touch-switching-modal-${this.selected_modal}`)?.css("height", this.modals[this.selected_modal].px_height)
            }
        },
        showModal: function(modal){

            this.resetModalInline()
            let this_class = this
            Object.keys(this.modals).forEach(function(key){
                if(key == modal){

                    $(`#one-touch-switching-modal-${key}`)?.css("display", this_class.modals[key].display)
                    $("#modal-box")?.css("background-color", this_class.modals[key].colour)
  
                    if(this_class.modals[key].width){
                        $("#modal-box")?.css("width", this_class.modals[key].width)
                    }
                    if(this_class.modals[key].px_height){
                        $("#modal-box")?.css("height", this_class.modals[key].px_height)
                    }
                    if(this_class.modals[key].center){
                        $("#modal-box")?.css("margin", "auto")
                    }
                    if(this_class.modals[key].maxWidth){
                        $("#modal-box")?.css("max-width", this_class.modals[key].maxWidth)
                    }
                    if(this_class.modals[key].minHeight){
                        $(`#one-touch-switching-modal-${key}`)?.css("min-height", this_class.modals[key].minHeight)
                    }
                    if(this_class.modals[key].invertCross){
                        $(".one-touch-switching-modal-close > img")?.attr("src", "/includes/assets/images/modal-cross-black.png");
                    }
                    else{
                        $(".one-touch-switching-modal-close > img")?.attr("src", "/includes/assets/images/modal-cross.png");
                    }

                    if(this_class.modals[key].noCross){
                        $(".one-touch-switching-modal-close")?.css("display", "none")

                        if(document.querySelector(".one-touch-switching-modal-box")){
                            document.querySelector(".one-touch-switching-modal-box").style.cssText += ' border-top-right-radius: 16px !important; '  
                        }
                    }
                    
                    $(".one-touch-switching-modal-close")?.css("background-color", this_class.modals[key].colour)

                    this_class.selected_modal = modal // set the modal that will be used in the resize listener
                    this_class.modalResize()
                }
                else{
                    $(`#one-touch-switching-modal-${key}`)?.css("display", "none")

                }
            })
            
        },

        testModeFunc: function(){
            if(this.test_mode){
                this.showModal(this.test_mode_type)
                
                return true;
            }
            return false;
        },
        
       

        resetModalInline: function(){
            if($("#modal-box")){
                $("#modal-box").css("width", "")
                $("#modal-box").css("height", "")
                $("#modal-box").css("max-width", "")
                $("#modal-box").css("background-color", "")
                $("#modal-box").css("margin", "")
                $(".one-touch-switching-modal-close")?.css("display", "")
                $("#modal-box").css("border-top-right-radius", "")
            }
        },
        resetModal: function() {
            let this_class = this
            $('body').removeClass('show-modal'); // close the modal
            //add the old close button back
            if(document.querySelector("#modal-box")?.querySelector("span")){
                document.querySelector("#modal-box").insertAdjacentHTML("afterbegin", `<span></span>`)
                $("#modal-box > span").on("click", () => {
                    $('body').removeClass('show-modal');
                })
            }

            this_class.resetModalInline()
            if($("#modal-box")){
                $("#modal-box").empty()
                $("#modal-box").append("<span class></span><div id='modal-body-box'></div>")
                $("#modal-box").removeClass("modal-box")
            }
        },
        setupModal: function (modal_type){
            let this_class = this

            let light_blue = "#EBF8FD"

            document.querySelector("#modal-box")?.querySelector("span")?.remove() // remove the currect close button 
            document.querySelector("#modal-container").style.flexDirection = "column"
            document.querySelector("#modal-box:not(:has(.one-touch-switching-modal-close))")?.insertAdjacentHTML("afterbegin", `<div class="one-touch-switching-modal-close" style="background-color: light_blue;" ><img src="/includes/assets/images/modal-cross.png"/></div>`)
            document.querySelector("#modal-box")?.classList.add("one-touch-switching-modal-box")
            

            $(".one-touch-switching-modal-close-button").on("click", () => {this_class.resetModal()})
            $(".one-touch-switching-modal-close").on("click", () => {this_class.resetModal()})


            this.showModal(modal_type)
            
            window.addEventListener("resize", () => {
                this.modalResize()
            })
        },
       
    },
    

 }